import { memo } from 'react';
import Typography from '../../../Typography';
import { AB3 } from '../../../../theme';
import { IComponentWithCustomScrollbarProps } from '../../../../services';
import Box from '../../../Box';
import { ScrollableBox } from '../../../ScrollableContainers';

interface IListItem {
  [key: string]: any;
}

export interface IPromptListProps extends IComponentWithCustomScrollbarProps {
  list: IListItem[];
  renderField: string;
  renderKey: string;
}

const DEFAULT_BOX_SX = { overflowY: 'auto' };
const SCROLLABLE_BOX_SX = { height: '100%', maxHeight: 190 };

const PromptList = (props: IPromptListProps) => {
  const {
    list, renderField, renderKey, disableCustomScrollbar = false,
  } = props;
  if (!list.length) return null;

  const processedList = list.map((item) => (
    <Typography noWrap color={AB3} key={item[renderKey]}>
      {item[renderField]}
    </Typography>
  ));

  if (disableCustomScrollbar) {
    return (
      <Box maxHeight={190} sx={DEFAULT_BOX_SX}>
        {processedList}
      </Box>
    );
  }

  return (
    <ScrollableBox sx={SCROLLABLE_BOX_SX}>
      {processedList}
    </ScrollableBox>
  );
};

export default memo(PromptList);
